import copy from 'fast-copy';


export const reportingReducer = (state, action) => {

  const newState = {};
  for (const key of Object.keys(action)) newState[key] = action[key];

  // const finalState = copy({...state, ...newState});
  // localStorage.setItem('reportingState', JSON.stringify({
  //   ...finalState,
  //   scenario: null, // Don't keep selected scenario
  //   scenarios: null, // Always refresh new scenarios
  //   reportingColumns: null, // Columns don't need to be saved locally
  //   settingsScenarios: null // Always refresh all scenarios for settings
  // }));

  // return finalState;
  return copy({ ...state, ...newState });

};
